import type { ApiEnvelope, ApiFailure, ApiSuccess } from '@/shared/types/api';

/**
 * Type guard: distinguishes a success envelope from a failure envelope.
 */
export function isApiFailure<T>(envelope: ApiEnvelope<T>): envelope is ApiFailure {
  return envelope.success === false;
}

export function isApiSuccess<T>(envelope: ApiEnvelope<T>): envelope is ApiSuccess<T> {
  return envelope.success === true;
}
